import type { TicketDto } from '@planuze/admin-contracts';
import { SUPPORT_CONTENT, type TicketStatusLabels } from '../../content/sections/support.js';

type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'destructive';

/* Tom do StatusBadge para status e prioridade de ticket — puro layout (não é texto), não
   entra no catálogo bilíngue. */
export function statusTone(status: TicketDto['status']): Tone {
  switch (status) {
    case 'open':
      return 'info';
    case 'in_progress':
      return 'warning';
    case 'closed':
      return 'neutral';
  }
}

/**
 * Rótulo do status no idioma corrente.
 *
 * `labels` é `useSupportContent().ticketStatusLabels`; o default pt-BR cobre chamadores
 * fora de componente (testes unitários).
 */
export function statusLabel(
  status: TicketDto['status'],
  labels: TicketStatusLabels = SUPPORT_CONTENT['pt-BR'].ticketStatusLabels,
): string {
  switch (status) {
    case 'open':
      return labels.open;
    case 'in_progress':
      return labels.inProgress;
    case 'closed':
      return labels.closed;
  }
}

export function priorityTone(priority: TicketDto['priority']): Tone {
  switch (priority) {
    case 'urgent':
      return 'destructive';
    case 'high':
      return 'warning';
    case 'normal':
      return 'info';
    case 'low':
      return 'neutral';
  }
}
